// import React, { useState, useRef, useEffect } from "react";

// export default function RichTextEditor({
//   editor,
//   editorContent,
//   showtoolbar,
//   onChange,
//   readOnly,
//   minHeight,
//   maxHeight,
//   editorId
// }) {
//   const [findText, setFindText] = useState("");
//   const [showFindBar, setShowFindBar] = useState(false);
//   const [activeFormats, setActiveFormats] = useState({});
//   const [activeHeadings, setActiveHeadings] = useState({
//     h1: false,
//     h2: false,
//   });

//   const executeCommand = (command, value = null) => {
//     editor.current.focus();
//     document.execCommand(command, false, value);
//     updateActiveFormats();
//   };

//   useEffect(() => {
//     if (readOnly) return;
//     const el = editor.current;
//     if (!el) return;

//     el.addEventListener("click", (e) => {
//       if (e.target.tagName === "IMG") {
//         el.querySelectorAll("img").forEach((img) =>
//           img.classList.remove("selected")
//         );
//         e.target.classList.add("selected");
//         enableResize(e.target);
//       }
//     });
//   }, [readOnly]);

//   const enableResize = (img) => {
//     let isResizing = false;
//     let startX, startWidth;

//     img.addEventListener("mousedown", (e) => {
//       const rect = img.getBoundingClientRect();
//       // Only start resizing near bottom-right corner
//       if (e.clientX > rect.right - 10 && e.clientY > rect.bottom - 10) {
//         isResizing = true;
//         startX = e.clientX;
//         startWidth = rect.width;
//         e.preventDefault();
//       }
//     });

//     document.addEventListener("mousemove", (e) => {
//       if (!isResizing) return;
//       const newWidth = startWidth + (e.clientX - startX);
//       img.style.width = newWidth + "px";
//       img.style.height = "auto"; // keep ratio
//     });

//     document.addEventListener("mouseup", () => {
//       isResizing = false;
//     });
//   };

//   const updateActiveFormats = () => {
//     setActiveFormats({
//       bold: document.queryCommandState("bold"),
//       italic: document.queryCommandState("italic"),
//       underline: document.queryCommandState("underline"),
//       strikeThrough: document.queryCommandState("strikeThrough"),
//       superscript: document.queryCommandState("superscript"),
//       subscript: document.queryCommandState("subscript"),
//       insertUnorderedList: document.queryCommandState("insertUnorderedList"),
//       insertOrderedList: document.queryCommandState("insertOrderedList"),
//     });
//   };

//   const insertLink = () => {
//     const selection = window.getSelection();
//     if (selection.rangeCount === 0) {
//       alert("Please select some text first");
//       return;
//     }

//     const url = prompt("Enter URL:", "https://");
//     if (url && url.trim() !== "" && url !== "https://") {
//       executeCommand("createLink", url);
//     }
//   };

//   const insertImage = () => {
//     const fileInput = document.createElement("input");
//     fileInput.type = "file";
//     fileInput.accept = "image/*"; // only image files
//     fileInput.style.display = "none";

//     fileInput.onchange = (e) => {
//       const file = e.target.files[0];
//       if (!file) return;
//       const reader = new FileReader();
//       reader.onload = (ev) => {
//         const base64Image = ev.target.result;
//         // Insert at cursor position
//         editor.current.focus();
//         document.execCommand("insertImage", false, base64Image);
//       };
//       reader.readAsDataURL(file); // Convert to Base64
//     };
//     document.body.appendChild(fileInput);
//     fileInput.click();
//     document.body.removeChild(fileInput);
//   };

//   const handleUndo = () => {
//     executeCommand("undo");
//   };

//   const handleRedo = () => {
//     executeCommand("redo");
//   };

//   const formatHeading = (level) => {
//     const key = `h${level}`;

//     if (activeHeadings[key]) {
//       // Reset to normal
//       executeCommand("fontSize", "3"); // Normal size
//       executeCommand("bold"); // Remove bold
//       setActiveHeadings({ ...activeHeadings, [key]: false });
//     } else {
//       // Apply heading format
//       executeCommand("fontSize", level === 1 ? "7" : "6");
//       executeCommand("bold");
//       setActiveHeadings({ ...activeHeadings, [key]: true });
//     }
//   };

//   const handleFind = () => {
//     if (findText) {
//       window.find(findText);
//     }
//   };

//   const handleCopy = () => {
//     document.execCommand("copy");
//   };

//   const handlePaste = async () => {
//     try {
//       const text = await navigator.clipboard.readText();
//       executeCommand("insertText", text);
//     } catch (err) {
//       console.error("Failed to paste:", err);
//     }
//   };

//   return (
//     <div className="editor-container">
//       <style>{`
//         @import url('https://fonts.googleapis.com/icon?family=Material+Icons');

//         * {
//           margin: 0;
//           padding: 0;
//           box-sizing: border-box;
//         }

//         body {
//           font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
//           background: #f5f5f5;
//         }

//         .editor-container {
//         //   max-width: 900px;
//         //   margin: 20px auto;
//           background: white;
//           border-radius: 8px;
//           box-shadow: 0 2px 8px rgba(0,0,0,0.1);
//           overflow: hidden;
//         }

//         .toolbar {
//           display: flex;
//           flex-wrap: wrap;
//           gap: 4px;
//           padding: 12px;
//           background: #f8f9fa;
//           border-bottom: 1px solid #dee2e6;
//         }

//         .toolbar-group {
//           display: flex;
//           gap: 4px;
//           padding-right: 8px;
//           border-right: 1px solid #dee2e6;
//         }

//         .toolbar-group:last-child {
//           border-right: none;
//         }

//         .toolbar-btn {
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           width: 36px;
//           height: 36px;
//           border: 1px solid #dee2e6;
//           background: white;
//           border-radius: 4px;
//           cursor: pointer;
//           transition: all 0.2s;
//           color: #495057;
//         }

//         .toolbar-btn:hover {
//           background: #e9ecef;
//           border-color: #adb5bd;
//         }

//         .toolbar-btn:active {
//           background: #dee2e6;
//         }

//         .toolbar-btn.active {
//           background: #1976d2;
//           color: white;
//           border-color: #1976d2;
//         }

//         .toolbar-btn.active:hover {
//           background: #1565c0;
//           border-color: #1565c0;
//         }

//         .material-icons {
//           font-size: 20px;
//           user-select: none;
//         }

//         .find-bar {
//           display: flex;
//           gap: 8px;
//           padding: 12px;
//           background: #fff3cd;
//           border-bottom: 1px solid #ffc107;
//           align-items: center;
//         }

//         .find-input {
//           flex: 1;
//           padding: 8px 12px;
//           border: 1px solid #dee2e6;
//           border-radius: 4px;
//           font-size: 14px;
//         }

//         .find-btn {
//           padding: 8px 16px;
//           background: #1976d2;
//           color: white;
//           border: none;
//           border-radius: 4px;
//           cursor: pointer;
//           font-size: 14px;
//           font-weight: 500;
//         }

//         .find-btn:hover {
//           background: #1565c0;
//         }

//         .close-btn {
//           padding: 8px 16px;
//           background: #6c757d;
//           color: white;
//           border: none;
//           border-radius: 4px;
//           cursor: pointer;
//           font-size: 14px;
//           font-weight: 500;
//         }

//         .close-btn:hover {
//           background: #545b62;
//         }

//         .editor-area-1 {
//           min-height: 460px !important;
//           max-height: 460px !important;
//           overflow-x: scroll;
//           overflow-y: scroll;
//           padding: 20px;
//           outline: none;
//           font-size: 16px;
//           line-height: 1.6;
//           color: #212529;
//           direction: ltr !important;
//           unicode-bidi: plaintext !important;
//         }

//         .editor-area-2 {
//           min-height: 450px !important;
//           max-height: 450px !important;
//           overflow-x: hidden;
//           overflow-y: auto;
//           padding: 20px;
//           outline: none;
//           font-size: 16px;
//           line-height: 1.6;
//           color: #212529;
//           direction: ltr !important;
//           unicode-bidi: plaintext !important;
//         }

//         .editor-area:focus {
//           outline: 2px solid #1976d2;
//           outline-offset: -2px;
//         }

//         .editor-area h1 {
//           font-size: 2em;
//           font-weight: bold;
//           margin: 0.67em 0;
//         }

//         .editor-area h2 {
//           font-size: 1.5em;
//           font-weight: bold;
//           margin: 0.75em 0;
//         }

//         .editor-area img {
//           max-width: 100%;
//           height: auto;
//           margin: 10px 0;
//         }

//         .editor-area a {
//           color: #1976d2;
//           text-decoration: underline;
//         }
        
//         .editor-area img {
//           max-width: 100%;
//           height: auto;
//           border: 1px solid transparent;
//           padding: 2px;
//         }

//         /* Show resize handle */
//         .editor-area img.selected {
//           outline: 2px solid #1976d2;
//           position: relative;
//         }

//         .editor-area img.selected::after {
//           content: "";
//           position: absolute;
//           bottom: -4px;
//           right: -4px;
//           width: 12px;
//           height: 12px;
//           background: #1976d2;
//           cursor: nwse-resize;
//           border-radius: 2px;
//         }

//         @media (max-width: 768px) {
//           .editor-container {
//             margin: 10px;
//           }

//           .toolbar {
//             gap: 2px;
//             padding: 1px;
//           }

//           .toolbar-btn {
//             width: 32px;
//             height: 28px;
//           }

//           .material-icons {
//             font-size: 18px;
//           }

//           /* View Only / Preview Mode */
// .editor-area.view-only {
//   border: none !important;
//   outline: none !important;
//   background: white !important;
//   padding: 10px 20px; /* cleaner margin */
//   cursor: default !important;
//   pointer-events: auto; /* allow text selection */
// }

// /* No resize handles in Preview */
// .editor-area.view-only img {
//   outline: none !important;
//   cursor: default !important;
// }

// .editor-area.view-only img::after {
//   display: none !important;
// }

// /* Remove Scroll bar look */
// .editor-area.view-only::-webkit-scrollbar {
//   width: 6px;
// }

// .editor-area.view-only::-webkit-scrollbar-thumb {
//   background: transparent;
// }
//         }
//       `}</style>

//       {showtoolbar && !readOnly && (
//         <div className="toolbar">
//           <div className="toolbar-group">
//             <button
//               className="toolbar-btn"
//               onClick={handleUndo}
//               title="Undo (Ctrl+Z)"
//             >
//               <span className="material-icons">undo</span>
//             </button>
//             <button
//               className="toolbar-btn"
//               onClick={handleRedo}
//               title="Redo (Ctrl+Y)"
//             >
//               <span className="material-icons">redo</span>
//             </button>
//           </div>

//           <div className="toolbar-group">
//             <button
//               className={`toolbar-btn ${activeHeadings.h1 ? "active" : ""}`}
//               onClick={() => formatHeading(1)}
//               title="Heading 1"
//             >
//               <span className="material-icons">looks_one</span>
//             </button>
//             <button
//               className={`toolbar-btn ${activeHeadings.h2 ? "active" : ""}`}
//               onClick={() => formatHeading(2)}
//               title="Heading 2"
//             >
//               <span className="material-icons">looks_two</span>
//             </button>
//           </div>

//           <div className="toolbar-group">
//             <button
//               className={`toolbar-btn ${activeFormats.bold ? "active" : ""}`}
//               onClick={() => executeCommand("bold")}
//               title="Bold (Ctrl+B)"
//             >
//               <span className="material-icons">format_bold</span>
//             </button>
//             <button
//               className={`toolbar-btn ${activeFormats.italic ? "active" : ""}`}
//               onClick={() => executeCommand("italic")}
//               title="Italic (Ctrl+I)"
//             >
//               <span className="material-icons">format_italic</span>
//             </button>
//             <button
//               className={`toolbar-btn ${
//                 activeFormats.underline ? "active" : ""
//               }`}
//               onClick={() => executeCommand("underline")}
//               title="Underline (Ctrl+U)"
//             >
//               <span className="material-icons">format_underlined</span>
//             </button>
//             <button
//               className={`toolbar-btn ${
//                 activeFormats.strikeThrough ? "active" : ""
//               }`}
//               onClick={() => executeCommand("strikeThrough")}
//               title="Strikethrough"
//             >
//               <span className="material-icons">strikethrough_s</span>
//             </button>
//           </div>

//           <div className="toolbar-group">
//             <button
//               className={`toolbar-btn ${
//                 activeFormats.superscript ? "active" : ""
//               }`}
//               onClick={() => executeCommand("superscript")}
//               title="Superscript"
//             >
//               <span className="material-icons">superscript</span>
//             </button>
//             <button
//               className={`toolbar-btn ${
//                 activeFormats.subscript ? "active" : ""
//               }`}
//               onClick={() => executeCommand("subscript")}
//               title="Subscript"
//             >
//               <span className="material-icons">subscript</span>
//             </button>
//           </div>

//           <div className="toolbar-group">
//             <button
//               className={`toolbar-btn ${
//                 activeFormats.insertUnorderedList ? "active" : ""
//               }`}
//               onClick={(e) => {
//                 e.preventDefault();
//                 executeCommand("insertUnorderedList");
//               }}
//               title="Unordered List"
//             >
//               <span className="material-icons">format_list_bulleted</span>
//             </button>
//             <button
//               className={`toolbar-btn ${
//                 activeFormats.insertOrderedList ? "active" : ""
//               }`}
//               onClick={(e) => {
//                 e.preventDefault();
//                 executeCommand("insertOrderedList");
//               }}
//               title="Ordered List"
//             >
//               <span className="material-icons">format_list_numbered</span>
//             </button>
//           </div>

//           <div className="toolbar-group">
//             <button
//               className="toolbar-btn"
//               onClick={() => executeCommand("justifyLeft")}
//               title="Align Left"
//             >
//               <span className="material-icons">format_align_left</span>
//             </button>
//             <button
//               className="toolbar-btn"
//               onClick={() => executeCommand("justifyCenter")}
//               title="Align Center"
//             >
//               <span className="material-icons">format_align_center</span>
//             </button>
//             <button
//               className="toolbar-btn"
//               onClick={() => executeCommand("justifyRight")}
//               title="Align Right"
//             >
//               <span className="material-icons">format_align_right</span>
//             </button>
//             <button
//               className="toolbar-btn"
//               onClick={() => executeCommand("justifyFull")}
//               title="Justify"
//             >
//               <span className="material-icons">format_align_justify</span>
//             </button>
//           </div>

//           <div className="toolbar-group">
//             <button
//               className="toolbar-btn"
//               onClick={(e) => {
//                 e.preventDefault();
//                 insertLink();
//               }}
//               title="Insert Link"
//             >
//               <span className="material-icons">link</span>
//             </button>
//             <button
//               className="toolbar-btn"
//               onClick={(e) => {
//                 e.preventDefault();
//                 insertImage();
//               }}
//               title="Insert Image"
//             >
//               <span className="material-icons">image</span>
//             </button>
//           </div>

//           <div className="toolbar-group">
//             <button
//               className="toolbar-btn"
//               onClick={(e) => {
//                 e.preventDefault();
//                 executeCommand("removeFormat");
//               }}
//               title="Clear Formatting"
//             >
//               <span className="material-icons">format_clear</span>
//             </button>
//           </div>

//           <div className="toolbar-group">
//             <button
//               className="toolbar-btn"
//               onClick={() => setShowFindBar(!showFindBar)}
//               title="Find (Ctrl+F)"
//             >
//               <span className="material-icons">search</span>
//             </button>
//             <button
//               className="toolbar-btn"
//               onClick={handleCopy}
//               title="Copy (Ctrl+C)"
//             >
//               <span className="material-icons">content_copy</span>
//             </button>
//             <button
//               className="toolbar-btn"
//               onClick={handlePaste}
//               title="Paste (Ctrl+V)"
//             >
//               <span className="material-icons">content_paste</span>
//             </button>
//           </div>
//         </div>
//       )}

//       {showFindBar && (
//         <div className="find-bar">
//           <input
//             type="text"
//             className="find-input"
//             placeholder="Find text..."
//             value={findText}
//             onChange={(e) => setFindText(e.target.value)}
//             onKeyPress={(e) => e.key === "Enter" && handleFind()}
//           />
//           <button className="find-btn" onClick={handleFind}>
//             Find
//           </button>
//           <button className="close-btn" onClick={() => setShowFindBar(false)}>
//             Close
//           </button>
//         </div>
//       )}

//       <div
//         ref={editor}
//         className={`editor-area-${editorId} ${readOnly ? "view-only" : ""}`}
//         contentEditable={!readOnly}
//         suppressContentEditableWarning
//         onMouseUp={!readOnly ? updateActiveFormats : undefined}
//         onKeyUp={!readOnly ? updateActiveFormats : undefined}
//         onClick={!readOnly ? updateActiveFormats : undefined}
//         onInput={!readOnly ? onChange : undefined}
//       >
//         {editorContent}
//       </div>
//     </div>
//   );
// }

import React, { useState, useRef, useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { IconButton } from "@material-ui/core";
import { Button } from "@mui/material";
import paraphrase_logo from "../../static/Paraphrase 1.png";
import paraphrase_Gray from "../../static/Paraphrase 2.png";
import { FaBookOpen } from "react-icons/fa";
import { Spellcheck } from "@mui/icons-material";
import { Delete } from "@mui/icons-material";
import UploadIcon from "@mui/icons-material/Upload";
import MicIcon from "@mui/icons-material/Mic";
import DownloadIcon from "@mui/icons-material/Download";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import TranslateIcon from "@mui/icons-material/Translate";

const CustomTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: "blue",
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}))(Tooltip);

export default function RichTextEditor({
  editor,
  editorContent,
  showtoolbar,
  onChange,
  readOnly,
  minHeight,
  maxHeight,
  editorId,
  placeholder,
  isGrammarCheck,
  mobileView,
  totalWords,
  accessToParaphrase,
  handleParaphraseClick,
  accessToSummarize,
  handleSummariserClick,
  accessToOCR,
  accessToDelete,
  handleDeleteFormain,
  accessToUpload,
  handleFileChange,
  docId,
  handleCopyFormain,
  accessToTranslate,
  handleTranslateClick,
  isRecording,
  handleMicClick,
  ocrCheck,
  grammarCheckClick,
  openDownloadModal,
  isEditorOnly = false,
  onMount,
}) {
  const [findText, setFindText] = useState("");
  const [showFindBar, setShowFindBar] = useState(false);
  const [activeFormats, setActiveFormats] = useState({});
  const [activeHeadings, setActiveHeadings] = useState({
    h1: false,
    h2: false,
  });

  const executeCommand = (command, value = null) => {
    editor.current.focus();
    document.execCommand(command, false, value);
    updateActiveFormats();
  };

  // useEffect(() => {
  //   if (editor.current && onMount) {
  //     onMount(editor.current);
  //   }
  // }, []);

  useEffect(() => {
    if (readOnly) return;
    const el = editor.current;
    if (!el) return;

    el.addEventListener("click", (e) => {
      if (e.target.tagName === "IMG") {
        el.querySelectorAll("img").forEach((img) =>
          img.classList.remove("selected")
        );
        e.target.classList.add("selected");
        enableResize(e.target);
      }
    });
  }, [readOnly]);

  // useEffect(() => {
  //   console.log("editorContent_",editor)
  //   if (editor.current && editorContent !== editor.current.innerHTML) {
  //     editor.current.innerHTML = editorContent || "";
  //   }
  // }, [editorContent]);

  const enableResize = (img) => {
    let isResizing = false;
    let startX, startWidth;

    img.addEventListener("mousedown", (e) => {
      const rect = img.getBoundingClientRect();
      // Only start resizing near bottom-right corner
      if (e.clientX > rect.right - 10 && e.clientY > rect.bottom - 10) {
        isResizing = true;
        startX = e.clientX;
        startWidth = rect.width;
        e.preventDefault();
      }
    });

    document.addEventListener("mousemove", (e) => {
      if (!isResizing) return;
      const newWidth = startWidth + (e.clientX - startX);
      img.style.width = newWidth + "px";
      img.style.height = "auto"; // keep ratio
    });

    document.addEventListener("mouseup", () => {
      isResizing = false;
    });
  };

  const updateActiveFormats = () => {
    setActiveFormats({
      bold: document.queryCommandState("bold"),
      italic: document.queryCommandState("italic"),
      underline: document.queryCommandState("underline"),
      strikeThrough: document.queryCommandState("strikeThrough"),
      superscript: document.queryCommandState("superscript"),
      subscript: document.queryCommandState("subscript"),
      insertUnorderedList: document.queryCommandState("insertUnorderedList"),
      insertOrderedList: document.queryCommandState("insertOrderedList"),
    });
  };

  const insertLink = () => {
    const selection = window.getSelection();
    if (selection.rangeCount === 0) {
      alert("Please select some text first");
      return;
    }

    const url = prompt("Enter URL:", "https://");
    if (url && url.trim() !== "" && url !== "https://") {
      executeCommand("createLink", url);
    }
  };

  const insertImage = () => {
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = "image/*"; // only image files
    fileInput.style.display = "none";

    fileInput.onchange = (e) => {
      const file = e.target.files[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = (ev) => {
        const base64Image = ev.target.result;
        // Insert at cursor position
        editor.current.focus();
        document.execCommand("insertImage", false, base64Image);
      };
      reader.readAsDataURL(file); // Convert to Base64
    };
    document.body.appendChild(fileInput);
    fileInput.click();
    document.body.removeChild(fileInput);
  };

  const handleUndo = () => {
    executeCommand("undo");
  };

  const handleRedo = () => {
    executeCommand("redo");
  };

  const formatHeading = (level) => {
    const key = `h${level}`;

    if (activeHeadings[key]) {
      // Reset to normal
      executeCommand("fontSize", "3"); // Normal size
      executeCommand("bold"); // Remove bold
      setActiveHeadings({ ...activeHeadings, [key]: false });
    } else {
      // Apply heading format
      executeCommand("fontSize", level === 1 ? "7" : "6");
      executeCommand("bold");
      setActiveHeadings({ ...activeHeadings, [key]: true });
    }
  };

  const handleFind = () => {
    if (findText) {
      window.find(findText);
    }
  };

  const handleCopy = () => {
    document.execCommand("copy");
  };

  const handlePaste = async () => {
    try {
      const text = await navigator.clipboard.readText();
      executeCommand("insertText", text);
    } catch (err) {
      console.error("Failed to paste:", err);
    }
  };

  return (
    <div className="editor-container">
      <style>{`
        @import url('https://fonts.googleapis.com/icon?family=Material+Icons');

        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        body {
          font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          background: #f5f5f5;
        }

        .editor-container {
        //   max-width: 900px;
        //   margin: 20px auto;
          background: white;
          border-radius: 8px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.1);
          overflow: hidden;
        }

        .toolbar {
          display: flex;
          flex-wrap: wrap;
          gap: 4px;
          padding: 12px;
          background: #f8f9fa;
          border-bottom: 1px solid #dee2e6;
        }

        .toolbar-group {
          display: flex;
          gap: 4px;
          padding-right: 8px;
          border-right: 1px solid #dee2e6;
        }

        .toolbar-group:last-child {
          border-right: none;
        }

        .toolbar-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 36px;
          height: 36px;
          border: 1px solid #dee2e6;
          background: white;
          border-radius: 4px;
          cursor: pointer;
          transition: all 0.2s;
          color: #495057;
        }

        .toolbar-btn:hover {
          background: #e9ecef;
          border-color: #adb5bd;
        }

        .toolbar-btn:active {
          background: #dee2e6;
        }

        .toolbar-btn.active {
          background: #1976d2;
          color: white;
          border-color: #1976d2;
        }

        .toolbar-btn.active:hover {
          background: #1565c0;
          border-color: #1565c0;
        }

        .material-icons {
          font-size: 20px;
          user-select: none;
        }

        .find-bar {
          display: flex;
          gap: 8px;
          padding: 12px;
          background: #fff3cd;
          border-bottom: 1px solid #ffc107;
          align-items: center;
        }

        .find-input {
          flex: 1;
          padding: 8px 12px;
          border: 1px solid #dee2e6;
          border-radius: 4px;
          font-size: 14px;
        }

        .find-btn {
          padding: 8px 16px;
          background: #1976d2;
          color: white;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          font-size: 14px;
          font-weight: 500;
        }

        .find-btn:hover {
          background: #1565c0;
        }

        .close-btn {
          padding: 8px 16px;
          background: #6c757d;
          color: white;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          font-size: 14px;
          font-weight: 500;
        }

        .close-btn:hover {
          background: #545b62;
        }

        .editor-area {
          min-height: 480px !important;
          max-height: 465px !important;
          overflow-x: hidden;
          overflow-y: auto;
          padding: 20px;
          outline: none;
          font-size: 16px;
          line-height: 1.6;
          color: #212529;
          direction: ltr !important;
          unicode-bidi: plaintext !important;
        }


        .editor-area:focus {
          outline: 2px solid #1976d2;
          outline-offset: -2px;
        }

        .editor-area h1 {
          font-size: 2em;
          font-weight: bold;
          margin: 0.67em 0;
        }

        .editor-area h2 {
          font-size: 1.5em;
          font-weight: bold;
          margin: 0.75em 0;
        }

        .editor-area img {
          max-width: 100%;
          height: auto;
          margin: 10px 0;
        }

        .editor-area a {
          color: #1976d2;
          text-decoration: underline;
        }
        
        .editor-area img {
          max-width: 100%;
          height: auto;
          border: 1px solid transparent;
          padding: 2px;
        }

        /* Show resize handle */
        .editor-area img.selected {
          outline: 2px solid #1976d2;
          position: relative;
        }

        .editor-area img.selected::after {
          content: "";
          position: absolute;
          bottom: -4px;
          right: -4px;
          width: 12px;
          height: 12px;
          background: #1976d2;
          cursor: nwse-resize;
          border-radius: 2px;
        }

         
        .editor-area ul,
        .editor-area ol {
          list-style-position: inside;   /* bullet move with text */
          padding-left: 0;
        }
        .editor-area li {
          text-align: inherit;
        }

        @media (max-width: 768px) {
          .editor-container {
            margin: 10px;
          }

          .toolbar {
            gap: 2px;
            padding: 8px;
          }

          .toolbar-btn {
            width: 32px;
            height: 32px;
          }

          .material-icons {
            font-size: 18px;
          }

  /* View Only / Preview Mode */
          .editor-area.view-only {
            border: none !important;
            outline: none !important;
            background: white !important;
            padding: 10px 20px; /* cleaner margin */
            cursor: default !important;
            pointer-events: auto; /* allow text selection */
          }

/* No resize handles in Preview */
          .editor-area.view-only img {
            outline: none !important;
            cursor: default !important;
          }

          .editor-area.view-only img::after {
            display: none !important;
          }

/* Remove Scroll bar look */
          .editor-area.view-only::-webkit-scrollbar {
            width: 6px;
          }

          .editor-area.view-only::-webkit-scrollbar-thumb {
            background: transparent;
          }

/* For Placeholder */
          .editor-area.show-placeholder::before {
            content: attr(data-placeholder);
            color: #999;
            font-style: italic;
            pointer-events: none;
            position: absolute;
          }

          .editor-area {
            position: relative;
          }

        }
      `}</style>

      {showtoolbar && !readOnly && (
        <div className="toolbar">
          <div className="toolbar-group">
            <button
              className="toolbar-btn"
              onClick={handleUndo}
              title="Undo (Ctrl+Z)"
            >
              <span className="material-icons">undo</span>
            </button>
            <button
              className="toolbar-btn"
              onClick={handleRedo}
              title="Redo (Ctrl+Y)"
            >
              <span className="material-icons">redo</span>
            </button>
          </div>

          <div className="toolbar-group">
            <button
              className={`toolbar-btn ${activeHeadings.h1 ? "active" : ""}`}
              onClick={() => formatHeading(1)}
              title="Heading 1"
            >
              <span className="material-icons">looks_one</span>
            </button>
            <button
              className={`toolbar-btn ${activeHeadings.h2 ? "active" : ""}`}
              onClick={() => formatHeading(2)}
              title="Heading 2"
            >
              <span className="material-icons">looks_two</span>
            </button>
          </div>

          <div className="toolbar-group">
            <button
              className={`toolbar-btn ${activeFormats.bold ? "active" : ""}`}
              onClick={() => executeCommand("bold")}
              title="Bold (Ctrl+B)"
            >
              <span className="material-icons">format_bold</span>
            </button>
            <button
              className={`toolbar-btn ${activeFormats.italic ? "active" : ""}`}
              onClick={() => executeCommand("italic")}
              title="Italic (Ctrl+I)"
            >
              <span className="material-icons">format_italic</span>
            </button>
            <button
              className={`toolbar-btn ${
                activeFormats.underline ? "active" : ""
              }`}
              onClick={() => executeCommand("underline")}
              title="Underline (Ctrl+U)"
            >
              <span className="material-icons">format_underlined</span>
            </button>
            <button
              className={`toolbar-btn ${
                activeFormats.strikeThrough ? "active" : ""
              }`}
              onClick={() => executeCommand("strikeThrough")}
              title="Strikethrough"
            >
              <span className="material-icons">strikethrough_s</span>
            </button>
          </div>

          <div className="toolbar-group">
            <button
              className={`toolbar-btn ${
                activeFormats.superscript ? "active" : ""
              }`}
              onClick={() => executeCommand("superscript")}
              title="Superscript"
            >
              <span className="material-icons">superscript</span>
            </button>
            <button
              className={`toolbar-btn ${
                activeFormats.subscript ? "active" : ""
              }`}
              onClick={() => executeCommand("subscript")}
              title="Subscript"
            >
              <span className="material-icons">subscript</span>
            </button>
          </div>

          <div className="toolbar-group">
            <button
              className={`toolbar-btn ${
                activeFormats.insertUnorderedList ? "active" : ""
              }`}
              onClick={(e) => {
                e.preventDefault();
                executeCommand("insertUnorderedList");
              }}
              title="Unordered List"
            >
              <span className="material-icons">format_list_bulleted</span>
            </button>
            <button
              className={`toolbar-btn ${
                activeFormats.insertOrderedList ? "active" : ""
              }`}
              onClick={(e) => {
                e.preventDefault();
                executeCommand("insertOrderedList");
              }}
              title="Ordered List"
            >
              <span className="material-icons">format_list_numbered</span>
            </button>
          </div>

          <div className="toolbar-group">
            <button
              className="toolbar-btn"
              onClick={() => executeCommand("justifyLeft")}
              title="Align Left"
            >
              <span className="material-icons">format_align_left</span>
            </button>
            <button
              className="toolbar-btn"
              onClick={() => executeCommand("justifyCenter")}
              title="Align Center"
            >
              <span className="material-icons">format_align_center</span>
            </button>
            <button
              className="toolbar-btn"
              onClick={() => executeCommand("justifyRight")}
              title="Align Right"
            >
              <span className="material-icons">format_align_right</span>
            </button>
            <button
              className="toolbar-btn"
              onClick={() => executeCommand("justifyFull")}
              title="Justify"
            >
              <span className="material-icons">format_align_justify</span>
            </button>
          </div>

          <div className="toolbar-group">
            <button
              className="toolbar-btn"
              onClick={(e) => {
                e.preventDefault();
                insertLink();
              }}
              title="Insert Link"
            >
              <span className="material-icons">link</span>
            </button>
            <button
              className="toolbar-btn"
              onClick={(e) => {
                e.preventDefault();
                insertImage();
              }}
              title="Insert Image"
            >
              <span className="material-icons">image</span>
            </button>
          </div>

          <div className="toolbar-group">
            <button
              className="toolbar-btn"
              onClick={(e) => {
                e.preventDefault();
                executeCommand("removeFormat");
              }}
              title="Clear Formatting"
            >
              <span className="material-icons">format_clear</span>
            </button>
          </div>

          <div className="toolbar-group">
            <button
              className="toolbar-btn"
              onClick={() => setShowFindBar(!showFindBar)}
              title="Find (Ctrl+F)"
            >
              <span className="material-icons">search</span>
            </button>
            <button
              className="toolbar-btn"
              onClick={handleCopy}
              title="Copy (Ctrl+C)"
            >
              <span className="material-icons">content_copy</span>
            </button>
            <button
              className="toolbar-btn"
              onClick={handlePaste}
              title="Paste (Ctrl+V)"
            >
              <span className="material-icons">content_paste</span>
            </button>
          </div>
        </div>
      )}

      {showFindBar && (
        <div className="find-bar">
          <input
            type="text"
            className="find-input"
            placeholder="Find text..."
            value={findText}
            onChange={(e) => setFindText(e.target.value)}
            onKeyPress={(e) => e.key === "Enter" && handleFind()}
          />
          <button className="find-btn" onClick={handleFind}>
            Find
          </button>
          <button className="close-btn" onClick={() => setShowFindBar(false)}>
            Close
          </button>
        </div>
      )}

      <div
        ref={editor}
        className={`editor-area ${readOnly ? "view-only" : ""}`}
        contentEditable={!readOnly}
        suppressContentEditableWarning
        onInput={!readOnly ? onChange : undefined}
      />

      {isEditorOnly && (
        <div
          className="d-flex changeBG borderTop"
          style={{
            justifyContent: mobileView ? "center" : "space-between",
            flexWrap: "wrap",
            alignItems: "center",
            gap: "5px",
            boxShadow: "5px 5px 15px rgba(0, 0, 0, 0.3), 0 0 0 white",
            padding: "5px",
            borderRadius: "0px 0px 8px 8px",
            minHeight: "50px",
          }}
        >
          <div className="px-2" style={{ display: mobileView ? "none" : "" }}>
            <h6
              style={{
                color: "#1976D2",
                fontSize: "13px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <FiberManualRecordIcon fontSize="small" />
              <b className="whiteHeading" style={{ marginLeft: "5px" }}>
                {" "}
                {totalWords} | 2500 words{" "}
              </b>
            </h6>
          </div>

          <div
          // style={{position:"relative", right:"9%"}}
          >
            <Button
              disabled={!accessToParaphrase}
              className="OutlinedDarkBtn2"
              style={{
                cursor: accessToParaphrase ? "pointer" : "not-allowed",
                fontSize: "12px",
                marginRight: "10px",
                borderRadius: "10px",
                textTransform: "capitalize",
                boxShadow: "3px 3px 8px rgba(0, 0, 0, 0.2)",
              }}
              onClick={handleParaphraseClick}
            >
              <img
                src={!accessToParaphrase ? paraphrase_Gray : paraphrase_logo}
                alt="Paraphrase"
                style={{ width: "21px", marginRight: "5px" }}
              />
              Paraphrase
            </Button>
            <Button
              disabled={!accessToSummarize}
              className="OutlinedDarkBtn2"
              style={{
                cursor: accessToSummarize ? "pointer" : "not-allowed",
                fontSize: "12px",
                marginRight: "10px",
                borderRadius: "10px",
                textTransform: "capitalize",
                boxShadow: "3px 3px 8px rgba(0, 0, 0, 0.2)",
              }}
              onClick={handleSummariserClick}
            >
              <FaBookOpen
                style={{
                  marginRight: "5px",
                  width: "18px",
                  height: "18px",
                }}
              />
              Summarize
            </Button>
            <Button
              disabled={!accessToOCR}
              onClick={() => ocrCheck()}
              className="OutlinedDarkBtn2"
              style={{
                textTransform: "capitalize",
                fontSize: mobileView ? "10px" : "12px",
                borderRadius: "10px",
                boxShadow: "3px 3px 8px rgba(0, 0, 0, 0.2)",
              }}
            >
              OCR
            </Button>
            {!isGrammarCheck && (
              <Button
                className="OutlinedDarkBtn2"
                style={{
                  cursor: "pointer",
                  marginLeft: "10px",
                  fontSize: "12px",
                  // marginRight: "10px",
                  borderRadius: "10px",
                  textTransform: "capitalize",
                  boxShadow: "3px 3px 8px rgba(0, 0, 0, 0.2)",
                }}
                onClick={grammarCheckClick}
              >
                <Spellcheck />
                Grammar Check
              </Button>
            )}
          </div>
          <div
            className="buttons-div"
            style={{
              width: mobileView ? "100%" : "",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div
              className="px-2"
              style={{ display: !mobileView ? "none" : "" }}
            >
              <h6 style={{ color: "#1976D2", fontSize: "10px" }}>
                <FiberManualRecordIcon fontSize="small" />
                <b className="whiteHeading"> {totalWords} words </b>
              </h6>
            </div>

            <div>
              <CustomTooltip title="Delete">
                <IconButton
                  disabled={!accessToDelete}
                  title={"Delete"}
                  style={{
                    fontSize: "8px",
                    marginLeft: "2px",
                    color: accessToDelete ? "red" : "#FF6B6B",
                    borderColor: "white",
                    width: mobileView ? "1px" : "",
                  }}
                  onClick={handleDeleteFormain}
                >
                  <Delete />
                </IconButton>
              </CustomTooltip>
              <CustomTooltip title="Upload and can also drag and drop document here">
                <IconButton
                  className="uploadcolor"
                  disabled={!accessToUpload}
                  title={"Upload"}
                  style={{
                    fontSize: "8px",
                    marginLeft: "2px",
                    borderColor: "white",
                    width: mobileView ? "1px" : "",
                  }}
                  component="label"
                  htmlFor="coAutherFileInput"
                  onClick={() => handleFileChange()}
                >
                  <UploadIcon />
                </IconButton>
              </CustomTooltip>
              {docId && (
                <CustomTooltip title="Download">
                  <IconButton
                    title={"Download"}
                    style={{
                      fontSize: "8px",
                      marginLeft: "2px",
                      color: "green",
                      borderColor: "white",
                      width: mobileView ? "1px" : "",
                    }}
                    onClick={() => {
                      openDownloadModal();
                    }}
                  >
                    <DownloadIcon />
                  </IconButton>
                </CustomTooltip>
              )}
              <CustomTooltip title="Copy">
                <IconButton
                  title={"Copy"}
                  style={{
                    fontSize: "8px",
                    marginLeft: "2px",
                    color: "blue",
                    borderColor: "white",
                    width: mobileView ? "1px" : "",
                  }}
                  onClick={handleCopyFormain}
                >
                  <ContentCopyIcon />
                </IconButton>
              </CustomTooltip>

              <CustomTooltip title="Translate">
                <IconButton
                  className="translateColor"
                  disabled={!accessToTranslate}
                  title="Translate"
                  style={{
                    fontSize: "8px",
                    marginLeft: "2px",
                    borderColor: "white",
                    width: mobileView ? "1px" : "",
                  }}
                  onClick={handleTranslateClick}
                >
                  <TranslateIcon />
                </IconButton>
              </CustomTooltip>

              <CustomTooltip title="Mic">
                <IconButton
                  title={"Mic"}
                  style={{
                    fontSize: "8px",
                    marginLeft: "2px",
                    color: isRecording ? "red" : "#FF6B6B",
                    borderColor: "white",
                    width: mobileView ? "1px" : "",
                  }}
                  onClick={handleMicClick}
                >
                  <MicIcon />
                </IconButton>
              </CustomTooltip>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

